import React, { lazy } from 'react';

const CostingPreviewDetailPDF = lazy(() =>
  import('../ProjectCostingPDF/CostingPreviewDetailPDF').then(module => ({
    default: module.CostingPreviewDetailPDF,
  })),
);

export const JournalEntryRoutes = [
  {
    props: {
      exact: true,
      path: '/project-journal/detail/:costAdjustmentID/journal-entry/e-letter',
    },
    component: (
      <CostingPreviewDetailPDF
        docType="journal-entry"
        accountType="project-costing"
        entityIdParam="costAdjustmentID"
      />
    ),
  },
];
